import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Header() {
  return (
    <header className="site-header">
      <div className="container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="Memorial Parque Dourados" className="logo-img" />
        </Link>
        <span className="header-phrase">Respeito, cuidado e memória para sempre.</span>
      </div>
    </header>
  );
}
